import { render, staticRenderFns } from "./skp.vue?vue&type=template&id=e2a777dc&"
import script from "./skp.vue?vue&type=script&lang=js&"
export * from "./skp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports